export const RISK_COLOR_MAP: Record<string, string> = {
  正常: "bg-emerald-100 text-emerald-700",
  低风险: "bg-yellow-100 text-yellow-700",
  中风险: "bg-orange-100 text-orange-700",
  高风险: "bg-red-100 text-red-700",
};
